const i18n = {
  'en-US': {
    'login.form.title': 'Login',
    'login.form.subtitle': 'cms-ui-locallife',
    'login.form.userName.errMsg': 'Username cannot be empty',
    'login.form.password.errMsg': 'Password cannot be empty',
    'login.form.captcha.errMsg': 'Captcha cannot be empty',
    'login.form.login.errMsg': 'Login error, please refresh and try again',
    'login.form.userName.placeholder': 'Username',
    'login.form.password.placeholder': 'Password',
    'login.form.rememberPassword': 'Remember password',
    'login.form.forgetPassword': 'Forgot password',
    'login.form.login': 'login',
    'login.form.register': 'register account',
    'login.banner.slogan1': 'AI efficient and intelligent hybrid cutting',
    'login.banner.subSlogan1': 'AI intelligent hybrid cutting, covering the most typical business scenarios',
    'login.banner.slogan2': 'Merchant Content Matrix Management',
    'login.banner.subSlogan2': 'Merchant content matrix management, automated marketing across the entire network',
    'login.banner.slogan3': 'Touch it, AI intelligent marketing',
    'login.banner.subSlogan3': 'Simple touch, more efficient content dissemination'
  },
  'zh-CN': {
    'login.form.title': '登录',
    'login.form.subtitle': '晓数智能 · 云剪平台',
    'login.form.userName.errMsg': '用户名不能为空',
    'login.form.password.errMsg': '密码不能为空',
    'login.form.captcha.errMsg': '验证码不能为空',
    'login.form.login.errMsg': '登录出错，请刷新重试',
    'login.form.userName.placeholder': '用户名',
    'login.form.password.placeholder': '密码',
    'login.form.rememberPassword': '记住密码',
    'login.form.forgetPassword': '忘记密码',
    'login.form.login': '登录',
    'login.form.register': '注册账号',
    'login.banner.slogan1': 'AI高效智能混剪',
    'login.banner.subSlogan1': 'AI智能混剪，覆盖最典型的商业场景',
    'login.banner.slogan2': '商家内容矩阵管理',
    'login.banner.subSlogan2': '商家内容矩阵管理，全网营销自动化',
    'login.banner.slogan3': '碰一碰，AI智能营销',
    'login.banner.subSlogan3': '简单碰一碰，内容传播更高效'
  }
};
export default i18n;